var _defs, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReliableServiceShieldTrane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48.3403 56.8694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lockFill",
    cx: 23.6388,
    cy: 30.913,
    r: 2.5217
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lockFill",
    x: 22.7515,
    y: 32.1739,
    width: 1.8238,
    height: 5.0435
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shieldPath",
    d: "M45.7701,24.4981c0,20.8762-18.504,28.7969-21.6,29.9725-2.964-1.1875-21.6-9.5-21.6-29.9725V6.9113L24.1701,2.375l21.6,4.5363v17.5869ZM24.1701,0L.1701,4.9875v19.5106C.1701,48.2481,23.5341,56.7744,23.7741,56.8575l.396.1425.396-.1306c.24-.0831,23.604-8.3125,23.604-32.3594V4.9875L24.1701,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lockFillAlternative",
    d: "M31.3206,23.1104v-3.2013c0-4.3312-3.4539-7.9091-7.6224-7.9091s-7.6224,3.5779-7.6224,7.9091v3.2013h-.3573c-.8933,0-1.5483.7533-1.5483,1.632v14.5c0,.8788.7146,1.632,1.5483,1.632h11.1484c.9494-.1109,1.0358-.601,1.0358-.8066s-.2738-.8255-1.0558-.8255l-10.0718-.2445c-.4169,0-.7742-.3766-.7742-.7533v-12.3784c0-.4394.3573-.9655.7742-.9655h13.9227c.4169,0,.7742.526.7742.9655v12.3156c0,.4394-.3573,1.0606-.7742,1.0606h-1.3368c-.1692,0-.6541.2929-.6541.8255s.4485.9321.6541.9321h2.2575c.8932,0,1.5483-.7533,1.5483-1.632v-14.6255c.0596-.8788-.6551-1.632-1.4888-1.632h-.3573ZM29.9675,23.1732h-.6716v-3.2013c0-3.2641-2.5607-5.9004-5.6573-5.9004-1.0719,0-1.7577.1346-2.6509.7623-.1786.1255-.5694.4917-.4626.9791.1068.4874.7076.6439.8863.5184.7742-.5022,1.5188-.831,2.466-.7533,2.2945.1883,3.7656,1.5693,3.7656,4.3939v3.2013h-7.9348v-3.2013c0-.8925.2229-1.7066.6101-2.4734.103-.2039.4354-.9726-.1901-1.3381-.1786-.1883-.8389-.1883-1.1496.3004-.7741,1.0043-.9973,2.1929-.9973,3.511v3.2013h-.6436v-3.2013c0-3.8918,2.5492-6.6792,6.3009-6.6792s6.3288,2.7874,6.3288,6.6792v3.2013Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "lockFill",
    cx: 23.6388,
    cy: 30.913,
    r: 2.5217
  }), /*#__PURE__*/React.createElement("g", {
    className: "lockAlternativeClipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lockFill",
    x: 20.117,
    y: 27.3913,
    width: 7.0435,
    height: 7.0435
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "lockFill",
    x: 22.7515,
    y: 32.1739,
    width: 1.8238,
    height: 5.0435
  }), /*#__PURE__*/React.createElement("g", {
    className: "lockClipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lockFill",
    x: 21.7515,
    y: 31.1739,
    width: 3.8238,
    height: 7.0435
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliableServiceShieldTrane);
export default __webpack_public_path__ + "static/media/reliable-service-shield-trane.65a7f39d567391392b112285f4db15bb.svg";
export { ForwardRef as ReactComponent };